exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-link-item{display:inline-block;vertical-align:top;margin-top:10px;width:10pc;min-height:10pc;margin-right:calc((100% - 960px)/5)}.form-link-item:nth-child(6n){margin-right:0}.form-link-item .form-link-btn{display:block;margin:0;position:relative;padding:10px 20px 20px;cursor:pointer;border-radius:3px;text-align:center;min-height:10pc}.form-link-item .form-link-name{font-size:1pc;text-align:center;text-decoration:none;color:#333}.form-link-item .form-link-btn:hover{background-color:#eee;text-decoration:none}.form-link-item .form-link-icon{position:relative;width:5pc;margin:auto}.form-link-item .form-link-counter{position:absolute;width:24px;text-align:center;height:24px;padding:0 5px;line-height:24px;background-color:#ff3b30;color:#fff;border-radius:9pt;top:0;right:0;cursor:default;font-size:1rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/MayoForm/components/style.css
 ** module id = 2285
 ** module chunks = 33 72
 **/